/**
 * @file Search Bar
 */

import { gsap } from 'gsap';

/**
 * Search Bar component
 */
const vSearchBar = () => {
	const searchBar = document.querySelector( '.v-search-bar' );

	if ( ! searchBar ) {
		return;
	}

	const searchTrigger = document.querySelector( '.v-header__search-trigger' );
	const searchClose   = searchBar.querySelector( '.v-search-bar__close' );
	const notSearch     = document.querySelector( '.v-not-search' );
	const input         = searchBar.querySelector( '.v-search-bar__input' );
	let animating       = false;

	/**
	 * Toggles search bar
	 */
	const toggleSearch = () => {
		if ( animating ) {
			return;
		}
		animating    = true;
		const isOpen = searchBar.classList.contains( 'v-search-bar--open' );

		if ( ! isOpen ) {
			searchBar.style.display = 'block';
		}

		searchTrigger.setAttribute( 'aria-expanded', isOpen ? 'false' : 'true' );
		searchClose.setAttribute( 'aria-expanded', isOpen ? 'false' : 'true' );

		gsap.timeline( {
			defaults: {
				ease:     'sine.out',
				duration: .4,
			},
			onComplete() {
				animating = false;

				if ( isOpen ) {
					notSearch.classList.remove( 'v-not-search--open' );
					searchBar.classList.remove( 'v-search-bar--open' );
				} else {
					notSearch.classList.add( 'v-not-search--open' );
					searchBar.classList.add( 'v-search-bar--open' );
				}

				searchBar.removeAttribute( 'style' );
				notSearch.removeAttribute( 'style' );

				if ( ! isOpen ) {
					input.focus();
				} else {
					searchTrigger.focus();
				}
			},
		} )
			.to( notSearch, {
				y: isOpen ? 0 : 96,
			} )
			.to( searchBar, {
				y: isOpen ? -96 : 0,
			}, '<' );
	};

	searchTrigger.addEventListener( 'click', toggleSearch );
	searchClose.addEventListener( 'click', toggleSearch );
};

export default vSearchBar;
